<template>
  <v-layout wrap>
    <v-flex md5>
      <v-flex>
        <h3 class="mb-5 d-inline-block">
          Curriculum
        </h3>
        <v-btn color="secondary" style="margin-top: -1px;" @click="downloadEntireCourse">
          Download All
        </v-btn>
      </v-flex>
      <v-treeview id="treeview" style="max-height: 300px; overflow-y: auto" :active.sync="active" :items="categorizedDirectories" :open.sync="open" activatable active-class="secondary--text" transition item-children="childItems" item-key="id" return-object>
        <template v-slot:prepend="{ item }">
          <v-icon v-if="item.courseItemComments.filter(x => !x.resolved && x.type === 'Required Change' && !x.parentCommentId).length > 0" color="error">
            error
          </v-icon>
          <v-icon v-else-if="item.courseItemComments.filter(x => !x.resolved && x.type === 'Suggested Change' && !x.parentCommentId).length > 0" color="info">
            help
          </v-icon>
          <v-icon v-else-if="item.courseItemComments.filter(x => !x.resolved && x.type === 'Comment' && !x.parentCommentId).length > 0">
            forum
          </v-icon>
          <v-icon v-else-if="item.courseItemComments.length > 0 && item.courseItemComments.filter(x => !x.parentCommentId).every(x => x.resolved)" color="teal">
            done
          </v-icon>
        </template>
      </v-treeview>
    </v-flex>

    <v-flex md7 class="pl-5">
      <div class="d-flex align-items-center mb-5">
        <span class="mb-0 h3">
          Peer Review {{ selectedFile ? '' : ' - Unresolved Comments' }}
        </span>
        <v-spacer />
        <div clas="text-right">
          <v-btn v-if="active.length > 0" flat @click="active = []">
            View All Comments
          </v-btn>
        </div>
      </div>
      <div>
        <v-scroll-y-transition mode="out-in">
          <div v-if="!selectedFile" class="title grey--text text--lighten-1 font-weight-light pt-3">
            <v-list v-if="unresolvedComments" two-line>
              <v-list-tile v-for="comment in unresolvedComments" :key="comment.dateTime+'-'+comment.itemId" @click="active.push(flatCategorizedArray.find(x => x.id === comment.itemId))">
                <v-list-tile-content>
                  <v-list-tile-title>{{ comment.type }} - {{ comment.datetime | formatShortDate }}</v-list-tile-title>
                  <v-list-tile-sub-title>{{ comment.itemName }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
            <div v-else>
              There are no unresolved comments at this time.
            </div>
          </div>
          <v-card v-else :key="selectedFile.id" class="mx-auto" flat>
            <v-card-title>
              <div>
                <p class="title mb-0">
                  <span v-if="selectedFile.type != 'directory'">
                    <a target="_blank" :href="'/resources/'+selectedFile.id" :download="selectedFile.name">{{ selectedFile.name }}</a>
                  </span>
                  <span v-else>
                    <span>{{ selectedFile.name }}</span>
                  </span>
                </p>
                <a v-if="selectedFile.editable" href="javascript:;" class="mb-0" @click="editFile">
                  Edit File
                </a>
              </div>
              <v-spacer />
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn flat v-on="on">
                    Actions
                  </v-btn>
                </template>
                <v-list>
                  <v-list-tile @click="triggerEditModal">
                    <v-list-tile-title>
                      <v-icon class="mr-2">
                        fas fa-edit
                      </v-icon> Update File
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="commentFormModal = true">
                    <v-list-tile-title>
                      <v-icon class="mr-2">
                        fas fa-plus-circle
                      </v-icon> New Comment
                    </v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-card-title>
            <v-card-text>
              <v-expansion-panel id="comments" v-model="commentExpansion">
                <v-expansion-panel-content v-for="comment in selectedComments" :key="comment.id">
                  <template v-slot:actions>
                    <v-icon v-if="comment.type === 'Required Change'" :color="comment.resolved ? 'teal': 'error'">
                      {{ comment.resolved ? 'done' : 'error' }}
                    </v-icon>
                    <v-icon v-if="comment.type === 'Suggested Change'" :color="comment.resolved ? 'teal': 'info'">
                      {{ comment.resolved ? 'done' : 'help' }}
                    </v-icon>
                    <v-icon v-if="comment.type === 'Comment'" :color="comment.resolved ? 'teal': ''">
                      {{ comment.resolved ? 'done' : 'forum' }}
                    </v-icon>
                  </template>
                  <template v-slot:header>
                    <div>{{ comment.type }} - {{ comment.datetime | formatShortDate }}</div>
                  </template>
                  <v-card>
                    <v-card-text class="grey lighten-3">
                      {{ comment.message }}
                      <p class="caption font-italic">
                        {{ comment.dateTime | formatShortDateTime }} by {{ comment.userFullName }}
                      </p>
                      <div class="mt-3">
                        <v-btn color="success" class="mx-0" :loading="resolvingComment" @click="addChildComment(comment.id)">
                          Add Comment
                        </v-btn>
                        <v-btn v-if="!comment.resolved && editAccess" color="info" :loading="resolvingComment" @click="resolveComment(comment)">
                          Resolve Comment
                        </v-btn>
                      </div>
                      <div v-if="comment.childComments.length > 0" class="pt-4">
                        <p class="headline">
                          Replies
                        </p>
                        <div v-for="childComment in comment.childComments" :key="childComment.id">
                          {{ childComment.message }}
                          <p class="caption font-italic">
                            {{ childComment.dateTime | formatShortDateTime }} by {{ childComment.userFullName }}
                          </p>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-card-text>
          </v-card>
        </v-scroll-y-transition>
      </div>
    </v-flex>

    <v-dialog v-model="commentFormModal" max-width="550px" lazy>
      <v-card>
        <alert-banner :msg="alertMessage" />
        <v-form @submit.prevent="submitCommentForm">
          <v-card-title>
            <span class="headline">
              New Comment
            </span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap row justify-center>
                <v-flex xs11>
                  <v-select v-model="commentForm.type" box :items="['Required Change', 'Suggested Change', 'Comment']" label="Request Type" :disabled="commentForm.parentCommentId != null" />
                  <v-textarea v-model="commentForm.message" box label="Feedback" />
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn flat @click="commentFormModal = false">
              Close
            </v-btn>
            <v-btn type="submit" color="secondary darken-1" flat :loading="savingCommentForm">
              Save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showEditDocModal" max-width="450px" lazy persistent>
      <v-card class="text-xs-center py-5">
        <v-progress-circular :size="70" :width="7" color="secondary" indeterminate />
        <p class="mt-5">
          Opening in a new window. Please wait...
        </p>
        <p>
          Larger files and PowerPoint files will take longer to load.
        </p>
      </v-card>
    </v-dialog>
    <edit-item-modal :dialog.sync="showEditItemModal" :course-id="courseId" :item="editingItemObject" :items.sync="categorizedDirectories" />
  </v-layout>
</template>
<script>
  import axios from 'axios';
  import { mapActions } from 'vuex';
  import ManageCourseBase from '../ManageCourseBase.vue';
  import EditItemModal from '../EditItemModal.vue';

  export default {
    components: {
      EditItemModal,
    },
    extends: ManageCourseBase,
    props: {
      editAccess: Boolean,
      isAdmin: Boolean,
    },

    data: () => ({
      active: [],
      open: [],
      selectedComments: [],
      showEditDocModal: false,
      showEditItemModal: false,
      editingItemObject: null,
      commentExpansion: 0,
      unresolvedComments: [],
      categorizedDirectories: [],
      savingCommentForm: false,
      defaultCommentForm: {
        parentCommentId: null,
        type: '',
        message: '',
        dateTime: '',
      },
      commentForm: {
        parentCommentId: null,
        type: '',
        message: '',
        dateTime: '',
      },
      commentFormModal: false,
      resolvingComment: false,
    }),

    computed: {
      selectedFile() {
        if (!this.active.length) return undefined;
        return this.active[0];
      },

      flatCategorizedArray() {
        const newArray = [];
        this.categorizedDirectories.forEach((item) => {
          newArray.push(item);
          if (item.childItems) {
            item.childItems.forEach((childItem) => {
              newArray.push(childItem);
              if (childItem.childItems) {
                childItem.childItems.forEach((childChildItem) => {
                  newArray.push(childChildItem);
                });
              }
            });
          }
        });

        return newArray;
      },
    },

    watch: {
      showEditItemModal(val) {
        if (!val) {
          this.active.push(this.flatCategorizedArray.find(x => x.id === this.selectedFile.id));
        }
      },

      selectedFile() {
        this.getFileComments();
      },

      commentFormModal(val) {
        if (!val) {
          this.clearCommentForm();
        }
      },
    },

    mounted() {
      this.getCategorized();
      this.getUnresolvedComments();
    },

    methods: {
      ...mapActions({
        setToast: 'toasts/addToGlobalToastQueue',
      }),

      async getCategorized() {
        const { data } = await axios.get(`/api/courses/${this.courseId}/items/categorized`);
        this.categorizedDirectories = data;
      },

      async getFileComments() {
        const { data } = await axios.get(`/api/courseitems/${this.selectedFile.id}/comments`);
        this.selectedComments = data;
      },

      async getUnresolvedComments() {
        const { data } = await axios.get(`/api/course/${this.courseId}/comments/unresolved`);
        this.unresolvedComments = data;
      },

      async resolveComment(comment) {
        this.resolvingComment = true;
        try {
          comment.resolved = true;
          const { data } = await axios.patch(`/api/courseitems/${this.selectedFile.id}/comments/${comment.id}`, comment);
          await this.getCategorized();
          await this.getFileComments();
          this.commentFormModal = false;
          this.setToast({
            color: 'success',
            message: 'Comment was resolved',
            multiline: false,
          });
        } catch (error) {
          comment.resolved = false;
          this.setToast({
            color: 'error',
            message: error.response.data[0],
            multiline: true,
          });
        } finally {
          this.resolvingComment = false;
        }
      },

      async editFile() {
        try {
          this.showEditDocModal = true;
          const { data } = await axios.get(`/api/courses/${this.courseId}/items/${this.selectedFile.id}/zoho-edit`);
          window.open(data);
        } catch (error) {
          this.setToast({
            color: 'error',
            message: error.response ? error.response.data : 'This file is not an editable file.',
            multiline: false,
          });
        }
        this.showEditDocModal = false;
      },

      async submitCommentForm() {
        this.savingCommentForm = true;
        try {
          this.commentForm.dateTime = new Date();
          const { data } = await axios.post(`/api/courseitems/${this.selectedFile.id}/comments`, this.commentForm);
          await this.getFileComments();
          await this.getCategorized();
          this.commentFormModal = false;
          this.setToast({
            color: 'success',
            message: 'Comment Saved',
            multiline: false,
          });
        } catch (error) {
          this.setToast({
            color: 'error',
            message: error.response.data[0],
            multiline: true,
          });
        } finally {
          this.savingCommentForm = false;
        }
      },

      clearCommentForm() {
        this.commentForm = JSON.parse(JSON.stringify(this.defaultCommentForm));
      },

      triggerEditModal() {
        this.showEditItemModal = true;
        this.editingItemObject = this.selectedFile;
      },

      addChildComment(commentId) {
        this.commentFormModal = true;
        this.commentForm.parentCommentId = commentId;
        this.commentForm.type = 'Comment';
      },

      async downloadEntireCourse() {
        const { data } = await axios.get(`/api/courses/${this.courseId}/`);
        if (data.fullDownloadUrl) {
          const { data } = await axios.get(`/api/courses/${this.courseId}/download`);
          window.location = data;
        } else {
          alert('Course is still being indexed, please wait a few minutes and try again');
        }
      },
    },
  };
</script>

<style scoped>
#treeview >>> .v-treeview-node__label {
  cursor: pointer;
}

#comments >>> .v-expansion-panel__container--active > .v-expansion-panel__header .v-expansion-panel__header__icon .v-icon {
  transform: rotate(0);
}

iframe {
  position:absolute;
    top:0;
    left:0;
    width:100%;
    height:100%;
}
</style>
